<template>
  <v-dialog v-model="enableModal" max-width="1000">
    <v-card>
      <v-card-title class="text-center">Писмы</v-card-title>
      <v-card-text class="card-text-container">
        <v-data-table v-if="mails"
                      :headers="tableHeaders"
                      :loading="loading"
                      :items="mails"
                      item-key="Uid"
                      class="elevation-1"
                      :server-items-length="total"
                      :options.sync="options"
                      :mobile-breakpoint="0"
                      dense
                      :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100] }"
                      @pagination="onRefreshed">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.index}}</td>
              <td @click="handleClick(item)"><a>{{ item.Uid }}</a></td>
              <td>{{ item.Receiver }}</td>
              <td>{{ item.Region }}</td>
              <td>{{ item.Area }}</td>
              <td>{{ item.Address }}</td>
              <td v-if="item.postIndex">{{ item.PostIndex.PostCode }}</td>
              <td v-else></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="modal-footer">
        <v-spacer></v-spacer>
        <div class="col-12 d-block d-md-flex align-center flex-md-row flex-column">
          <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-end">
            <v-btn color="danger" class="mr-2" @click="closeModal">Закрыть</v-btn>
            <v-btn color="warning" class="mr-2" @click="onExcel">Загрузить в Excel</v-btn>
          </v-col>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { LAYOUT_LOADING_START, LAYOUT_LOADING_STOP } from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service";
import XLSX from "xlsx";
import Moment from "moment";

export default {
  name: "TaskPerformanceAreaMailsModalComponent",
  data() {
    return {
      total: 0,
      mails: [],
      fileName: "",
      options: {
        sortBy: [],
        descending: false,
        page: 1,
        itemsPerPage: 5
      },
      enableModal: false,
      loading: false,
      records: [],
      tableHeaders: [
        {text: '№', value: 'index'},
        {text: 'Идентификатор', value: 'Uid'},
        {text: 'Получатель', value: 'Receiver'},
        {text: 'Область', value: 'Region'},
        {text: 'Район', value: 'Area'},
        {text: 'Адрес', value: 'Address'},
        {text: 'Пост индекс', value: 'PostIndex.PostCode'}
      ],
    };
  },
  methods: {
    handleClick(item) {
      this.$router.push({name: 'mail', params: {uid: item.Uid}});
    },
    set(filter, region, area, filters, count, fileName) {
      this.fileName = fileName;
      this.enableModal = true;
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      const {start, end, isAllClientsSelected, clients, isArchive} = filters;

      MailService.getTaskPerformanceAreaUids({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        selectedRegion: region,
        selectedArea: area,
        selectedFilter: filter,
        isAllClientsSelected: isAllClientsSelected,
        clients: clients,
        isArchive: isArchive
      })
          .then(response => {
            this.update(response.data, fileName)
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
            this.mails = []
          });

      this.$store.dispatch(LAYOUT_LOADING_STOP);
      this.loading = false;
    },
    update(items, fileName) {
      this.fileName = fileName;
      this.total = items.length
      this.records = items
      this.enableModal = true;
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      const startIndex = (this.options.page - 1) * this.options.itemsPerPage;
      const endIndex = startIndex + this.options.itemsPerPage;
      const slicedItems = items.slice(startIndex, endIndex);

      MailService.getByUids(slicedItems)
          .then(response => {
            this.mails = response.data.map((record, index) => ({...record, index: index + 1}));
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          });
    },
    onExcel() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      MailService.getByUids(this.records)
          .then(response => {
            var mails = response.data.map((record, index) => ({...record, index: index + 1}));
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([
              [
                '№',
                'Идентификатор',
                'Получательw',
                'Область',
                'Район',
                'Адрес',
                'Пост индекс'
              ],
            ]);

            worksheet['!cols'] = [{width: 10}, {width: 20}, {width: 15}, {width: 15}, {width: 20}, {width: 15}, {width: 15}, {width: 20}, {width: 25}, {width: 20}];
            worksheet['!rows'] = [{hpx: 25}];

            for (let i = 1; i <= 10; i++) {
              const cellAddress = XLSX.utils.encode_cell({r: 0, c: i - 1});
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              cell.s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
                fill: {
                  fgColor: {rgb: '4472C4'},
                },
                border: {
                  top: {style: 'thin', color: {rgb: '000000'}},
                  bottom: {style: 'thin', color: {rgb: '000000'}},
                  left: {style: 'thin', color: {rgb: '000000'}},
                  right: {style: 'thin', color: {rgb: '000000'}},
                },
              };
            }

            mails.forEach((item, index) => {
              const row = [
                index + 1,
                item.Uid ? item.Uid : '',
                item.Receiver ? item.Receiver : '',
                item.Region ? item.Region : '',
                item.Area ? item.Area : '',
                item.Address ? item.Address : '',
                item.PostIndex ? item.PostIndex.PostCode : '',
              ];

              XLSX.utils.sheet_add_aoa(worksheet, [row], {origin: index + 1});
            });

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            const excelBuffer = XLSX.write(workbook, {type: 'array', bookType: 'xlsx'});
            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.fileName + '.xlsx');
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          });
    },
    onRefreshed() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      const startIndex = (this.options.page - 1) * this.options.itemsPerPage;
      const endIndex = startIndex + this.options.itemsPerPage;
      const slicedItems = this.records.slice(startIndex, endIndex);

      MailService.getByUids(slicedItems)
          .then(response => {
            this.mails = response.data.map((record, index) => ({...record, index: index + 1}));
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          });
    },
    closeModal() {
      this.records = null;
      this.enableModal = false;
      this.$emit('close-modal');
    }
  }
};
</script>

<style scoped>
.modal-footer {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 2;
}

.card-text-container {
  max-height: 400px;
  overflow-y: auto;
}

.card-text-container::-webkit-scrollbar {
  width: 10px;
}

.card-text-container::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 3px;
}

.card-text-container::-webkit-scrollbar-track {
  background-color: #c4c4c4;
  border-radius: 3px;
}
</style>
